import { render } from "./App.vue?vue&type=template&id=caa9ba0c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=caa9ba0c&lang=scss"
script.render = render

export default script